import {
  EpisodeCardDimensions,
  EpisodeCardGutterSpacing,
  EpisodeCardVariants,
} from '@/containers';

export const CAROUSEL_ITEMS_PER_SCROLL = 2;
export const CAROUSEL_ITEM_WIDTH =
  EpisodeCardDimensions[EpisodeCardVariants.MEDIUM].width +
  EpisodeCardGutterSpacing[EpisodeCardVariants.MEDIUM] * 8;
